import { createContext } from "react";

const NotificationContext = createContext({
  notifications: [],
  setNotficaitions: () => {},
  showNotifications: false,
  setShowNotifications: () => {},
});

export default NotificationContext;
